import { useEffect, useState } from "react";

function since(iso: string | null | undefined): number {
  if (!iso) return 0;
  return Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
}

/** Seconds elapsed since `startedAt`, ticking once a second. 0 when there is no start. */
export function useElapsedSeconds(startedAt: string | null | undefined): number {
  const [elapsed, setElapsed] = useState(() => since(startedAt));

  useEffect(() => {
    setElapsed(since(startedAt));
    if (!startedAt) return;
    const id = setInterval(() => setElapsed(since(startedAt)), 1000);
    return () => clearInterval(id);
  }, [startedAt]);

  return elapsed;
}
